import { CART_CHECKOUT_BASE_URL } from '@src/global/App/constants/constants';
import axios from 'axios';

interface GetVSLinkResponse {
  data: string;
}

export const getVSLink = async (almId: string): Promise<GetVSLinkResponse> => {
  try {
    const response = await axios.get(
      `${CART_CHECKOUT_BASE_URL}/vitalsource/link/${almId}`
    );
    return response;
  } catch (error) {
    console.error('Error fetching vital source link:', error);
    throw error;
  }
};
